export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS

  /* eslint-disable */

  	// Testimonial Slider
  	if ($('#about-slider-two').length) {
  	    setTimeout(function() {
  		    var aboutSlideTwo = $('#about-slider-two').lightSlider({
  		        item: 1,
  		        autoWidth: false,
  		        slideMove: 1, // slidemove will be 1 if loop is true

  		        mode: 'fade',
  		        useCSS: true,
  		    
  		        speed: 400, //ms'
  		        auto: false,
  		        loop: false,
  		        slideEndAnimation: false,
  		    
  		        keyPress: false,
  		        controls: false,
  		        prevHtml: '',
  		        nextHtml: '',
  		    
  		        rtl: false,
  		        adaptiveHeight: false,
  		   
  		        pager: false,
  		        gallery: false,
  		        thumbMargin: 30,
  		        currentPagerPosition: 'left',
  		    
  		        enableTouch: true,
  		        enableDrag: true,
  		        freeMove: false,
  		        swipeThreshold: 1,
  		    
  		        responsive : [ ],
  		    
  		        onBeforeStart: function (el) { 

  	            },
  		        onSliderLoad: function (el) { },
  		        onBeforeSlide: function (el) {
  		        	
  		        	$('#experience-testimonials .lightSlider .bws-slide').addClass('transition');

  		        },
  		        onAfterSlide: function (el) {

  		        	$('#experience-testimonials .lightSlider .bws-slide.active').removeClass('transition');
  		        	let currentSlide = $('#about-section-three .lightSlider .bws-slide.active').data('count');
  		        	// console.log(currentSlide)


  		        	$('#experience-testimonials .bws-pager .bws-title').removeClass('active');
  		        	$('#experience-testimonials .bws-pager .bws-title[data-thumb=' + (currentSlide) + ']').addClass('active');

  		        },
  		        onBeforeNextSlide: function (el) {},
  		        onBeforePrevSlide: function (el) {}
  		    });
  		   

  		    let currentSlide = $('.bws-slide.active').data('count', 1);

  		    $('#experience-testimonials .bws-pager .bws-title').click(function(e) {
  		    	e.preventDefault();

  		    	$('#experience-testimonials .bws-pager .bws-title').removeClass('active');
  		    	let makeActive = $(this).data('thumb');
  		    	$(this).addClass('active');


  		    	$('#experience-testimonials .lightSlider .bws-slide.active').removeClass('active');
  		    	$('#experience-testimonials .lightSlider .bws-slide[data-count=' + makeActive + ']').addClass('transition');

  		    	$('#experience-testimonials .lightSlider .bws-slide').removeClass('transition');
  		    	aboutSlideTwo.goToSlide(makeActive - 1);
  		    });
  	    }, 500);
  	}

  	/* eslint-enable */
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/experience.js